import { render } from "./EditOrganizationDialog.vue?vue&type=template&id=380a2a0c&scoped=true"
import script from "./EditOrganizationDialog.vue?vue&type=script&lang=js"
export * from "./EditOrganizationDialog.vue?vue&type=script&lang=js"

import "./EditOrganizationDialog.vue?vue&type=style&index=0&id=380a2a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380a2a0c"]])

export default __exports__